import PropTypes from "prop-types";

export const ITEMS_PER_PAGE = 100;

export const TEMPLATE_PROP_TYPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  preset: PropTypes.bool,
  activationState: PropTypes.string,
  documentBundle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    documents: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          document: PropTypes.shape({
            name: PropTypes.string.isRequired,
            notarizationRequired: PropTypes.bool.isRequired,
            esign: PropTypes.bool.isRequired,
            witnessRequired: PropTypes.bool.isRequired,
            signerCanAnnotate: PropTypes.bool.isRequired,
            s3OriginalAsset: PropTypes.shape({
              url: PropTypes.string.isRequired,
            }).isRequired,
            filesize: PropTypes.number.isRequired,
          }),
        }),
      ),
    }),
  }).isRequired,
}).isRequired;
